import { inject,Injectable } from '@angular/core';
import { HttpService } from '@docpath/linces-angular-components/common';
import { Observable } from 'rxjs';
import { EndPoints } from 'src/app/constants/end-points';

import { GeneralConfig } from '../general-config.model';

@Injectable({
    providedIn: 'root'
})
export class GeneralHttpService {

    readonly relativeUrl = `${EndPoints.ENDPOINT_WEB_API}/${EndPoints.ENDPOINT_CONFIGURATION}/${EndPoints.ENDPOINT_CONFIGURATION_GENERAL}`;

    private readonly httpService = inject(HttpService);

    getConfig(): Observable<GeneralConfig> {
        return new Observable(observer => {
            this.httpService.get({
                relativeUrl: this.relativeUrl,
                loading: true,
                suscribe: response => {
                    const config = response.result as unknown as GeneralConfig;
                    observer.next(config);
                    observer.complete();
                }
            });
        });

    }

    updateConfig(config: GeneralConfig): Observable<void> {
        return new Observable(observer => {
            this.httpService.put(config, {
                relativeUrl: this.relativeUrl,
                loading: true,
                suscribe: () => {
                    observer.next();
                    observer.complete();
                },
                toast: 'general.toast.success'
            });
        });
    }
}
